import React from 'react'
import { Box, Chip, Typography } from '@mui/material'
import CustomTooltip from '../../../CustomTooltip'
import { ToolTipWrapper } from '../ObjectList/styles'
import { grey } from '../../../../colors'
import { InsightTooltip, type OverflowClickHandler } from '../OverflowIndicator'

export interface DataItem {
  title: string
  value: string
}

interface ChipsDisplayProps {
  data: DataItem[]
  onOverflowClick?: OverflowClickHandler
}

// It shows the first chip by default and truncates the rest, displaying them inside a tooltip.
// Each chip can show additional information when hovered over.

const ChipsForAttributes: React.FC<ChipsDisplayProps> = ({ data, onOverflowClick }) => {
  const visibleChips = data.slice(0, 1)
  const remainingChips = data.slice(1)
  const overflowCount = remainingChips.length

  const renderChips = (chips: DataItem[], subTooltips = false): JSX.Element[] => {
    return chips.map((chip: DataItem, index: number) => (
      <Box key={`${chip.title}-${chip.value}-${index}`}>
        <CustomTooltip title={<Typography>{chip.title}</Typography>}>
          <Chip size="small" label={chip.value} variant="outlined" color="primary" sx={{ background: subTooltips ? grey[25] : 'unset' }} />
        </CustomTooltip>
      </Box>
    ))
  }

  const Title = (): JSX.Element => (
    <Box display="flex" gap={1} flexWrap="wrap">
      {renderChips(remainingChips, true)}
    </Box>
  )

  return (
    <Box display="flex" justifyContent="flex-start" alignItems="center" gap={1}>
      {renderChips(visibleChips)}

      {overflowCount > 0 && (
        <ToolTipWrapper onClick={onOverflowClick}>
          <InsightTooltip count={overflowCount} tooltipTitle={<Title />} onClick={onOverflowClick}>
            <Typography component="span" fontSize={14}>{`+${overflowCount}`}</Typography>
          </InsightTooltip>
        </ToolTipWrapper>
      )}
    </Box>
  )
}

export default ChipsForAttributes
